/**
 * Helpers partagés pour les pages /moto-ecoles/* (SEO + Claim + Opposition).
 * Base juridique CNIL : données publiques Sécurité Routière uniquement.
 */
import { useEffect } from 'react';

export const API = process.env.REACT_APP_BACKEND_URL;
export const SITE_NAME = 'CODE 2 ROUES';
export const CONTACT_EMAIL = 'contact@code2roues.fr';

/** Met à jour title + meta description + canonical + JSON-LD. */
export function useSeoMeta({ title, description, canonicalPath, jsonLd }) {
  useEffect(() => {
    if (title) document.title = title;
    if (description) {
      let el = document.querySelector('meta[name="description"]');
      if (!el) {
        el = document.createElement('meta');
        el.setAttribute('name', 'description');
        document.head.appendChild(el);
      }
      el.setAttribute('content', description);
    }
    if (canonicalPath) {
      let link = document.querySelector('link[rel="canonical"]');
      if (!link) {
        link = document.createElement('link');
        link.setAttribute('rel', 'canonical');
        document.head.appendChild(link);
      }
      link.setAttribute('href', `https://code2roues.fr${canonicalPath}`);
    }
    // JSON-LD
    const oldLd = document.getElementById('seo-jsonld-annuaire');
    if (oldLd) oldLd.remove();
    if (jsonLd) {
      const script = document.createElement('script');
      script.id = 'seo-jsonld-annuaire';
      script.type = 'application/ld+json';
      script.textContent = JSON.stringify(jsonLd);
      document.head.appendChild(script);
    }
    return () => {
      const el = document.getElementById('seo-jsonld-annuaire');
      if (el) el.remove();
    };
  }, [title, description, canonicalPath, JSON.stringify(jsonLd || {})]);
}

export function formatDateFR(iso) {
  if (!iso) return '';
  try {
    return new Date(iso).toLocaleDateString('fr-FR', { day: '2-digit', month: 'long', year: 'numeric' });
  } catch { return ''; }
}

export function permisLabel(code) {
  return { A: 'Permis A', A1: 'Permis A1 · 125', A2: 'Permis A2', AM: 'Permis AM · BSR' }[code] || code;
}
